var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDefaultAvatar = function SvgDefaultAvatar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "#F9FAFC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.842 32.128c-.649-1.482-3.783-2.47-5.872-3.388-2.09-.918-1.808-1.482-1.878-2.245-.014-.099-.014-.212-.014-.325.72-.635 1.299-1.51 1.68-2.513 0 0 .014-.056.028-.07.085-.212.155-.452.212-.678.48-.099.762-.621.86-1.101.114-.198.326-.678.283-1.228-.07-.706-.353-1.03-.663-1.158v-.127c0-.89-.085-2.188-.24-3.035a4.213 4.213 0 0 0-.156-.706 5.184 5.184 0 0 0-1.807-2.626c-.903-.664-2.16-1.03-3.275-1.03-1.115 0-2.372.352-3.261 1.03a5.243 5.243 0 0 0-1.807 2.626c-.07.24-.127.466-.155.706-.17.847-.24 2.132-.24 3.035v.113c-.34.127-.636.452-.706 1.172-.043.536.183 1.016.282 1.214.113.494.395 1.016.89 1.101.056.24.127.466.211.692 0 .014.014.028.014.042l.014.014c.382 1.017.989 1.906 1.723 2.541 0 .1-.014.198-.014.297-.07.762.14 1.327-1.934 2.245-2.09.917-5.224 1.906-5.873 3.388-.65 1.482-.382 2.358-.382 2.358h22.476c-.014.014.254-.862-.396-2.344Z",
    fill: "#355B98"
  })));
};
export default SvgDefaultAvatar;